<template>
  <div class="site-shell">
    <TheNavbar />
    <main class="site-main">
      <transition
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
        appear
      >
        <div class="page-content" :key="$route.path">
          <slot></slot>
        </div>
      </transition>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheNavbar from "@/components/TheNavbar";
import TheFooter from "@/components/TheFooter";

export default {
  name: "Layout",
  components: { TheNavbar, TheFooter },
};
</script>
